import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const RoleRoute = ({ roles, children }) => {
  const user = useSelector((state) => state.session.user);
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) {
    return <div className="mx-auto max-w-3xl p-8 text-lg text-gray-800">You do not have access to this page.</div>;
  }
  return children;
};

export default RoleRoute;
